import { render } from "./yearSb.vue?vue&type=template&id=6aba5e0a&scoped=true"
import script from "./yearSb.vue?vue&type=script&lang=js"
export * from "./yearSb.vue?vue&type=script&lang=js"

import "./yearSb.vue?vue&type=style&index=0&id=6aba5e0a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aba5e0a"]])

export default __exports__